import React from 'react'
import "./NavBar.scss";
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import { UserInfoStateRecoil } from '../../utilities/globaleState';
import { NavLink } from 'react-router-dom';
import { useLogout } from '../../hooks';
import policeLogo from '../../assets/images/logo/police.jpeg';

function NavBar() {
 const navigate = useNavigate();
 const [userInfoState] = useRecoilState(UserInfoStateRecoil);
 const { logout } = useLogout();   
  return (
    <div className='sidebar'>
        <div className="sidebar__header">
           <img src={policeLogo} alt="Logo Police" className="sidebar__logo-image" />
           <h1 className="sidebar__logo-text">Portière</h1>
        </div>
        
        <nav className="sidebar__nav">
           <NavLink to="/tableau-board" className={(navData) => navData.isActive ? "sidebar__link sidebar__link--active" : "sidebar__link"}>
              <svg className="sidebar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
              <span>Tableau de bord</span>
           </NavLink>
           
           <NavLink to="/newrecepisse" className={(navData) => navData.isActive ? "sidebar__link sidebar__link--active" : "sidebar__link"}>
              <svg className="sidebar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 5v14M5 12h14"></path>
              </svg>
              <span>Nouveau</span>
           </NavLink>
           
           <NavLink to="/liste" className={(navData) => navData.isActive ? "sidebar__link sidebar__link--active" : "sidebar__link"}>
              <svg className="sidebar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
              <span>Liste</span>
           </NavLink>
        </nav>
        
        <div className="sidebar__footer">
           <button className="sidebar__logout" onClick={() => logout()}>
              <svg className="sidebar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>Déconnexion</span>
           </button>
        </div>
    </div>
  )
}

export default NavBar